import * as React from 'react';
import assign = require('object-assign');
import translate from '../../../../locale/translate';

import { Tag } from '../../../../store/models';

import { CustomerSelect } from '../../../reportSettings';

import { CheckboxInput } from '../Input';
import { IInputChangeEventHandler } from '../../../../interfaces';

interface ISettings {
    displayAgents: boolean,
    displayContainers: boolean,
}

interface IProps {
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export { ISettings };

export default class NodeFilterEditor extends React.Component<IProps, void> {
    static propTypes = {
        settings: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired,
    };

    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { handleChange, settings } = this.props;

        return (
            <div>
                <CheckboxInput
                    name="displayContainers"
                    label={translate.gettext("Display systems")}
                    checked={settings.displayContainers}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displayAgents"
                    label={translate.gettext("Display sensors")}
                    checked={settings.displayAgents}
                    onChange={this.handleChange.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Editor/NodeSystemFilterEditor.tsx